import { AdaaHelper } from "../../../../../../../core/utils";
import { Constants } from "../../../../../../constants/constants";
import type { ProjectComment } from "../../../../../../models";
import { SharedFields } from "../../configs";
import { ListSectionConfigType, ScreenSectionConfigType } from "../../wf-difference.types";

const weightField: ScreenSectionConfigType = {
  field: "weight",
  label: "common.tables.weight",
  view: "normal",
};

const progressField: ScreenSectionConfigType = {
  field: "progressActual",
  label: "common.tables.progress",
  view: "normal",
};

const commentsField: ListSectionConfigType = {
  field: "comments",
  label: "national_projects.comments",
  view: "list",
  idKey: "id",
  derivedList: (data: unknown) => {
    const comments = (data ?? []) as ProjectComment[];
    return comments.filter((comment) => comment.status !== Constants.OBJECT_STATUS.REMOVE);
  },
  format: (comment: ProjectComment) => AdaaHelper.getItemValueByToken(comment, "comments"),
};

export const govTaskScreenConfig = {
  type: "gov-project",
  sections: [
    ...SharedFields.name,
    ...SharedFields.description,
    SharedFields.startDate,
    SharedFields.endDate,
    weightField,
    progressField,
    commentsField,
    SharedFields.attachmentsField,
  ],
};
